// extracted by mini-css-extract-plugin
export default {"Container":"TableInfo-module__Container--aUG9D"};